<template>
  <div class="top-bar">
    <span class="typo-xl-bold">마이페이지</span>
    <img
      class="top-bar__home-icon"
      src="@/assets/home/icn_home_line.png"
      alt="home"
      @click="$emit('home-click')"
    />
  </div>
</template>

<script>
export default {
  name: 'TopBar',
}
</script>

<style scoped>
.top-bar {
  display: inline-flex;
  width: 100%;
  height: 64px;
  padding: 16px 16px 17px 16px;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}

.top-bar__home-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/TopBar.vue